const getCommonLabels = ($gettext) => {
  const labels = {
    __all__: '',
    comments_party: $gettext('Party'),
    comments_secretariat: $gettext('Secretariat'),
    recall: $gettext('Recall'),
    process: $gettext('Process'),
    finalize: $gettext('Finalize'),
    submit: $gettext('Submit'),
    other: $gettext('Other'),
    data_entry: $gettext('Data entry in progress'),
    has_exports: $gettext('Exports'),
    has_produced: $gettext('Production'),
    has_destroyed: $gettext('Destruction'),
    has_nonparty: $gettext('Non-Party'),
    has_emissions: $gettext('Emissions'),
    delete_submission: $gettext('Delete Submission'),
    versions: $gettext('Versions'),
    has_imports: $gettext('Imports'),
    sub_info: $gettext('Submission information'),
    questionaire_questions: $gettext('Questionnaire'),
    submitted: $gettext('Submitted'),
    processing: $gettext('Processing'),
    recalled: $gettext('Recalled'),
    finalized: $gettext('Finalized'),
    nomination_filled: $gettext('Nomination filled'),
    unrecall_to_submitted: $gettext('Reinstate'),
    unrecall_to_processing: $gettext('Reinstate'),
    unrecall_to_finalized: $gettext('Reinstate'),
    reporting_officer: $gettext('Name of reporting officer'),
    designation: $gettext('Designation'),
    organization: $gettext('Organization'),
    postal_code: $gettext('Postal code'),
    essencrit: $gettext('Essential and critical uses'),
    postal_address: $gettext('Postal address'),
    country: $gettext('Address country'),
    phone: $gettext('Phone'),
    reporting_channel: $gettext('Reporting channel'),
    email: $gettext('E-mail'),
    date: $gettext('Document date'),
    fill_nomination: $gettext('Submit nomination'),
    submitted_at: $gettext('Date submission'),
    art7: $gettext('Article 7'),
    hat: $gettext('HAT'),
    submission_format: $gettext('Submission format'),
    valid: $gettext('valid'),
    invalid: $gettext('invalid'),
    questionnaire_remarks_party: $gettext('Comments (Party)'),
    questionnaire_remarks_secretariat: $gettext('Comments (Secretariat)'),
    edit: $gettext('Edit'),
    view: $gettext('View'),
    revise: $gettext('Revise'),
    delete: $gettext('Delete'),
    flags: {
      flag_superseded: $gettext('Superseded'),
      flag_provisional: $gettext('Provisional'),
      flag_checked_blanks: $gettext('Checked blanks'),
      flag_has_blanks: $gettext('Has blanks'),
      flag_valid: $gettext('Valid'),
      flag_confirmed_blanks: $gettext('Confirmed blanks'),
      flag_has_reported_a1: $gettext('A/I'),
      flag_has_reported_a2: $gettext('A/II'),
      flag_has_reported_b1: $gettext('B/I'),
      flag_has_reported_b2: $gettext('B/II'),
      flag_has_reported_b3: $gettext('B/III'),
      flag_has_reported_c1: $gettext('C/I'),
      flag_has_reported_c2: $gettext('C/II'),
      flag_has_reported_c3: $gettext('C/III'),
      flag_has_reported_e: $gettext('E/I'),
      flag_has_reported_f: $gettext('F')
    },
    recall_tooltip: $gettext('NB: Recalling is best used when the data is to be withdrawn because it is completely wrong or significantly different from the correct data, otherwise it is advisable to revise and correct the wrong aspects of the data.')
  }
  return labels
}

export {
  getCommonLabels
}
